import Image from "../fragments/Image";
import Gallery from "../fragments/Gallery";
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

export default function Media({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const mediaRevealRef = useReveal({ once: true });
    const mediaAltRevealRef = useReveal({ once: true });

    let colClass = 'l-grid__col ';
    if (block.alignment === 'left') {
        colClass += 'l-grid__col--m-7-12 l-grid__col--l-8-12'
    } else if (block.alignment === 'right') {
        colClass += 'l-grid__col--m-7-12 l-grid__col--l-8-12 l-grid__col--m-push-5-12 l-grid__col--l-push-4-12'
    }
    colClass += ' c-transition-in';

    const slides = block.slides || [];

    if (slides.length === 1) {
        const slide = slides[0];
        return (
            <div className={`c-page__block c-page__block--media`}>
                <div className={`l-grid`}>
                    <div className={colClass} ref={mediaRevealRef}>
                        <Image 
                            src={slide.img_src || []} 
                            width={block.media_width} 
                            height={block.media_height} 
                            alt={slide.img_alt || ''} 
                        />
                    </div>
                </div>
            </div>
        );
    } else if (slides.length > 1) {
        return (
            <div className={`c-page__block c-page__block--media`}>
                <div className={`l-grid`}>
                    <div className={colClass} ref={mediaRevealRef}>
                        <Gallery 
                            media={slides} 
                            width={block.media_width} 
                            height={block.media_height} 
                        />
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
}